export default __webpack_public_path__ + "static/media/Perk_3.40d855c1.png";